import { createContext } from "react";

const ShowFooter_Context = createContext();

export default ShowFooter_Context;